import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "relatorio",
})
export class RelatorioPipe implements PipeTransform {
  transform(itens: any[], args: any, auth: boolean = true): any {
    let qtd = 0;
    let totalValor = 0;
    let aux;
    // Se existe algum parametro
    if (args) {
      args = Array.isArray(args) ? args : new Array(args) //Força a entrada a ser um array
      args.forEach(arg => {
        qtd += itens.filter((r) => r.discriminator === arg).length;
        itens.forEach((i) => {
          if (i.discriminator === arg) {
            totalValor += i.valor;
          }
        });
      });
    }
    else {
      qtd = itens.length;
      itens.forEach((i) => {
        totalValor += i.valor;
      });
    }
    const retorno = auth
      ? `${qtd}   \t${totalValor
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")}`
      : `${qtd} - R$ ${totalValor
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")}`;
    return retorno;
  }
}

/* transform(itens: any[], ...args: any[]): any {
      let qtd = 0;
      let totalValor = 0;
      // Se existe algum parametro
      if (args[0]) {
        qtd = itens.filter((r) => r.discriminator === args[0]).length;
        itens.forEach((i) => {
          if (i.discriminator === args[0]) {
            totalValor += i.valor;
          }
        });
      } else {
        qtd = itens.length;
        itens.forEach((i) => {
          totalValor += i.valor;
        });
      }
      const retorno = args[1]
        ? `${qtd}   \t${totalValor
            .toFixed(2)
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")}`
        : `${qtd} - R$ ${totalValor
            .toFixed(2)
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")}`;
      return retorno;
    } */